import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, RouterState } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { Address } from 'src/app/models/address';
import { Assignor } from 'src/app/models/assignor';
import { Auth } from 'src/app/models/auth';
import { CardSolicitationItems } from 'src/app/models/card-solicitation';
import { CollaboratorAddress } from 'src/app/models/colaborador';
import { EnderecoCep, EnderecoCidade } from 'src/app/models/endereco';
import { SolicitCardRequest } from 'src/app/models/request/card-solicitation-request';
import { CardsLimitsResponse, Collaborators, CollaboratorWithoutCardResponse } from 'src/app/models/response/card-solicitation-response';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CardSolicitationService } from 'src/app/services/card-solicitation.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { EnderecoService } from 'src/app/services/endereco.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cartoes-fisicos-pedido',
  templateUrl: './cartoes-fisicos-pedido.component.html',
  styleUrls: ['./cartoes-fisicos-pedido.component.css']
})
export class CartoesFisicosPedidoComponent implements OnInit {

    @ViewChild('modalAvisoEndereco', { static: true })
    modalAvisoEndereco: TemplateRef<any>;

    @ViewChild('modalAvisoLimite', { static: true })
    modalAvisoLimite: TemplateRef<any>;

    @ViewChild('modalAvisoColaboradores', { static: true })
    modalAvisoColaboradores: TemplateRef<any>;

    @ViewChild('modalEndereco', { static: true })
    modalEndereco: TemplateRef<any>;

    private currentUser: Auth;
    private selectedCollaborator: Collaborators;
    public offset: number = 0;
    public currentPage: number = 1;
    public showItem = '10';
    public totalItems: number = 0;
    public count = 0;

    public collaboratorWithoutCardResponse: CollaboratorWithoutCardResponse;
    public collaborators: Collaborators[]=[];
    public collaboratorsList: Collaborators[]=[];
    public collaboratorsId: any[]=[];
    showcollaborators: boolean = false;

    public assignorInfo: Assignor = new Assignor()
    public assignorAddressInfo: Address = new Address();

    public quantityCardsCtrl: FormControl = new FormControl();
    quantityCards: number = 0;
    totalQuantityCards: number = 0;

    public cardsLimits: CardsLimitsResponse = new CardsLimitsResponse();
    disableQuantityInput: boolean = false;

    addressModalLabel: string = 'Cadastrar';
    isEditing: boolean = false;
    public MASKS = MASKS;
    collaboratorAddressFormGroup: FormGroup;
    private addressCEP: EnderecoCep;
    private enderecoCidade: EnderecoCidade[];
    emptyCity: boolean = true;
    emptyUf: boolean = true;

    private addressTypeId = 3 // Correspondência

    //#region Filtro
    filtroOn: boolean;
    public filtroNome: string = '';
    public filtroDocumento: string = '';
    public nameCtrl: FormControl = new FormControl();
    public documentCtrl: FormControl = new FormControl();
    //#endregion

    constructor(
        private router: Router,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private _formBuilder: FormBuilder,
        private authenticationService: AuthenticationService,
        private cardSolicitationService: CardSolicitationService,
        private assignorService: CedenteService,
        private collaboratorService: ColaboradorService,
        private addressService: EnderecoService,
    ) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        // this.getTotalCollaborators();
        this.createForm(null);
    }

    private createForm(address: CollaboratorAddress) {
        this.collaboratorAddressFormGroup = this._formBuilder.group({
            cep: new FormControl(address?.cep, [
                Validators.required,
                NgBrazilValidators.cep
            ]),
            address: new FormControl(address?.address, [
                Validators.maxLength(500),
                Validators.required
            ]),
            number: new FormControl(address?.number, [
                Validators.maxLength(10),
                Validators.required
            ]),
            complement: new FormControl(address?.complement, [
                Validators.maxLength(50)
            ]),
            neighborhood: new FormControl(address?.neighborhood, [
                Validators.maxLength(200),
                Validators.required
            ]),
            city: new FormControl(address?.city, [
                Validators.required
            ]),
            uf: new FormControl(address?.uf, [
                Validators.required,
            ])
        });
    }

    getTotalCollaborators(){
        this.collaboratorService.getTotalCollaborators(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if(response.result <= 0){
                    this.modalService.open(this.modalAvisoColaboradores,{ centered: true, size: 'lg', backdrop: 'static' })
                }
                else {
                    this.getCardsLimits();
                }
            }
        )
    }


    getCardsLimits(){
        this.cardSolicitationService.cardsLimits(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.cardsLimits = response.result;
               /* if (this.cardsLimits.solicitedCards > this.cardsLimits.collaboratorsWithoutCard && this.cardsLimits.){
                    this.disableQuantityInput = true;
                    this.showLimitWarning();
                }
                else{*/
                    this.getAssignorInfo();
                    this.getAddress();
                    this.getCollaborators();
                    this.setTotalQuantityCards();
                //};
            }, error => {
                this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
            }
        );
    }

    getAssignorInfo(){
        if(JSON.parse(localStorage.getItem('assignorInfo')) == null || JSON.parse(localStorage.getItem('assignorInfo')) == undefined)   {
            this.assignorService.getAssignorInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    this.assignorInfo = response.result;
                    //this.assignorAddressInfo = this.assignorInfo.endereco;

                }, error => {
                    this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
                }
            );
        }
        else{
            this.assignorInfo = JSON.parse(localStorage.getItem('assignorInfo'));
            //this.assignorAddressInfo = this.assignorInfo.endereco;
        }
    }

    getAddress(){
        this.assignorService.getAddress(this.currentUser.token.assignorGuid,this.addressTypeId).subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.assignorAddressInfo = response.result;
                }

                if(response.status == ApiError.Insucesso && !response.result)
                {
                    this.modalService.open(this.modalAvisoEndereco, { centered: true, size: 'lg', backdrop: 'static' });
                }

                if(response.status == ApiError.ErroDeSistema) return this.alertService.error(response.message);

            }, error => console.log(error.message)
        )
    }

    getCollaborators(){
        this.cardSolicitationService.collaboratorsWithoutCard(this.currentUser.token.assignorGuid, this.offset, parseInt(this.showItem), this.filtroNome, this.filtroDocumento).subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.collaboratorWithoutCardResponse = response.result;
                    this.totalItems = this.collaboratorWithoutCardResponse.totalCollaborators;
                    this.collaborators = this.collaboratorWithoutCardResponse.collaborators;
                    for (const s of this.collaborators) {
                        s.id = s.collaboratorId;
                        s.selected = this.collaboratorsId.find(e => e === s.collaboratorId)? true : false;
                        // s.useAddress = this.collaboratorsId.find(e => e === s.collaboratorId) ? this.collaboratorsList.find(e => e.collaboratorId === s.collaboratorId).useAddress : false;
                        //s.collaboratorHasAddress = s.collaboratorId % 2 == 0 ? true : false;

                        if(s.collaboratorDocument != null){
                            const tam =
                                environment.TOTAL_CARACTERE_CPF -
                                s.collaboratorDocument.length;
                            let str = s.collaboratorDocument.toString();

                            for (let i = 0; i < tam; i++) {
                                str = '0' + str;
                            }

                            s.collaboratorDocument = str;
                        }
                    }
                }
            },
            error => {console.log(error)}
        )
    }

    solicitCard(){
        let quantityCards = (this.quantityCardsCtrl.value != null && this.quantityCardsCtrl.value != '' && this.quantityCardsCtrl.value != ' ') ? parseInt(this.quantityCardsCtrl.value) : null;

        if(!this.showcollaborators && quantityCards == null){
            this.quantityCardsCtrl.setErrors({'required': true});
            this.quantityCardsCtrl.markAsTouched();
            return;
        }

        let solicitCardRequest = new SolicitCardRequest();
        solicitCardRequest.assignorGuid = this.currentUser.token.assignorGuid;
        solicitCardRequest.managerGuid = this.currentUser.token.userReferenceId;
        solicitCardRequest.cardSolicitationItems = [];

        if(!this.showcollaborators && quantityCards != null){
            solicitCardRequest.cardSolicitationItems[0] = new CardSolicitationItems();
            solicitCardRequest.cardSolicitationItems[0].personGuid = this.currentUser.token.pessoaId;
            solicitCardRequest.cardSolicitationItems[0].quantityCards = quantityCards;
        }

        if(this.showcollaborators){
            for(let i = 0; i < this.collaboratorsList.length; i++){
                solicitCardRequest.cardSolicitationItems[i] = new CardSolicitationItems();
                solicitCardRequest.cardSolicitationItems[i].collaboratorId = this.collaboratorsList[i].collaboratorId;
                solicitCardRequest.cardSolicitationItems[i].useCollaboratorAddress = this.collaboratorsList[i].useAddress;
                solicitCardRequest.cardSolicitationItems[i].quantityCards = 1;
            }
            if(quantityCards != null){
                let cardSolicitationItem: CardSolicitationItems = new CardSolicitationItems();
                cardSolicitationItem.personGuid = this.currentUser.token.pessoaId;
                cardSolicitationItem.quantityCards = quantityCards;
                solicitCardRequest.cardSolicitationItems.push(cardSolicitationItem);
            }
        }
        let totalQuantityCards = 0;
        for(var i = 0; i < solicitCardRequest.cardSolicitationItems.length; i++)
                totalQuantityCards = totalQuantityCards + solicitCardRequest.cardSolicitationItems[i].quantityCards;

        if (totalQuantityCards > this.cardsLimits.cardsLimit){
            this.alertService.error("Quantidade de cartões é maior que o permitido! O valor excede o limite permitido da empresa.")
            return;
        }

        this.cardSolicitationService.solicit(solicitCardRequest).subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.alertService.success("Pedido efetuado com sucesso!");
                    this.router.navigate(['portal/cartoes/list']);
                }
                else{
                    this.alertService.error(response.message);
                }
            },
            error => { console.log(error) }
        )

    }

    semNumero(number: any){
        if(number == null || number == '' || !+number){
            this.collaboratorAddressFormGroup.get('number').setValue("S/N");
        }
    }

    getAddressZipCode(cep: string) {
        if (this.collaboratorAddressFormGroup.get('cep').valid && this.collaboratorAddressFormGroup.get('cep').value !== null) {
            this.addressService.getCEP(cep.replace(/\D+/g, '')).subscribe(
                response => {
                    this.addressCEP = response.result;
                    if(this.addressCEP.uf == null || this.addressCEP.cidade == null){
                        this.emptyUf = false;
                        this.emptyCity = false;
                    }
                    this.setAddress(this.addressCEP);

                }, error => { this.alertService.error('CEP não localizado!'); console.log(error)}
            );

        }
    }

    setAddress(enderecoCEP?: EnderecoCep) {
        if (enderecoCEP) {
            this.getCity(enderecoCEP.uf);
            this.collaboratorAddressFormGroup.patchValue({
                address: enderecoCEP.logradouro,
                neighborhood: enderecoCEP.bairro,
                city: enderecoCEP.cidade,
                uf: enderecoCEP.uf,
                cep: enderecoCEP.cep,
                number: 'S/N'
            });
        } else {
            return;
        }

    }

    getCity(uf: string) {
        if(uf == null || uf.replace(/\s/g,'') === '')
            uf = null;

        if (uf) {
            this.addressService.getCidade(uf).subscribe(
                response => {
                    this.enderecoCidade = response.result;
                },
                error => {
                    this.alertService.error('Não foi possível carregar as cidades');
                }
            );
        }
    }

    createAddress(){
        if(!this.collaboratorAddressFormGroup.valid){
            return false;
        }
        const collaboratorAddress = new CollaboratorAddress();
        collaboratorAddress.cep = this.collaboratorAddressFormGroup.get('cep').value.replace(/\D+/g, '');
        collaboratorAddress.address = this.collaboratorAddressFormGroup.get('address').value;
        collaboratorAddress.number = this.collaboratorAddressFormGroup.get('number').value;
        collaboratorAddress.complement = this.collaboratorAddressFormGroup.get('complement').value;
        collaboratorAddress.neighborhood = this.collaboratorAddressFormGroup.get('neighborhood').value;
        collaboratorAddress.city = this.collaboratorAddressFormGroup.get('city').value;
        collaboratorAddress.uf = this.collaboratorAddressFormGroup.get('uf').value;

        this.collaboratorService.createCollaboratorAddress(this.selectedCollaborator.collaboratorId, this.currentUser.token.assignorGuid, collaboratorAddress).subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.selectedCollaborator.collaboratorHasAddress = true;
                    this.selectedCollaborator.useAddress = true;
                    this.selectElement(this.selectedCollaborator, true);
                }
            },
            error => { console.log(error) }
        )
    }

    updateAddress(){
        if(!this.collaboratorAddressFormGroup.valid){
            return false;
        }
        const collaboratorAddress = new CollaboratorAddress();
        collaboratorAddress.cep = this.collaboratorAddressFormGroup.get('cep').value.replace(/\D+/g, '');
        collaboratorAddress.address = this.collaboratorAddressFormGroup.get('address').value;
        collaboratorAddress.number = this.collaboratorAddressFormGroup.get('number').value;
        collaboratorAddress.complement = this.collaboratorAddressFormGroup.get('complement').value;
        collaboratorAddress.neighborhood = this.collaboratorAddressFormGroup.get('neighborhood').value;
        collaboratorAddress.city = this.collaboratorAddressFormGroup.get('city').value;
        collaboratorAddress.uf = this.collaboratorAddressFormGroup.get('uf').value;

        this.collaboratorService.updateCollaboratorAddress(this.selectedCollaborator.collaboratorId, this.currentUser.token.assignorGuid, collaboratorAddress).subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.selectedCollaborator.collaboratorHasAddress = true;
                    this.selectedCollaborator.useAddress = true;
                    this.selectElement(this.selectedCollaborator, true);
                }
            },
            error => { console.log(error) }
        )
    }

    selectElement(item: Collaborators, v: boolean = false, dismiss: boolean = false) {
        this.selectedCollaborator = item;

        if(!v){
            item.selected = !item.selected;
            if(item.collaboratorHasAddress)
                item.useAddress = true;
            if(!item.collaboratorHasAddress && !dismiss){
                this.addressModalLabel = "Cadastrar";
                this.isEditing = false;
                this.createForm(null);
                this.modalService.open(this.modalEndereco, { centered: true, size: 'lg', backdrop: 'static' });
            }
        }

        if (!v && item.selected && !this.collaboratorsId.find(e => e === item.collaboratorId)) {
            this.collaboratorsList.push(item);
            this.collaboratorsId.push(item.collaboratorId);
        } else if (!v)  {
            this.collaboratorsList = this.collaboratorsList.filter(e => e.collaboratorId !== item.collaboratorId);
            this.collaboratorsId = this.collaboratorsId.filter(e => e  !== item.collaboratorId);
            item.useAddress = false;
        }

        this.count = this.collaboratorsId.length;
        this.setTotalQuantityCards();
    }

    editAddress(item: Collaborators){
        this.addressModalLabel = "Editar";
        this.isEditing = true;
        this.collaboratorService.getCollaboratorAddress(item.collaboratorId, this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.createForm(response.result);
                this.modalService.open(this.modalEndereco, { centered: true, size: 'lg', backdrop: 'static' });
            }
        );

    }

    addressDismiss(){
        this.selectElement(this.selectedCollaborator, false, true)
    }

    setTotalQuantityCards(){
        this.quantityCards = ((this.quantityCardsCtrl.value != null && this.quantityCardsCtrl.value != '' && this.quantityCardsCtrl.value != ' ') ? parseInt(this.quantityCardsCtrl.value) : 0)
        this.totalQuantityCards = this.count + this.quantityCards; //+ this.cardsLimits.cardsAdditionValue;
    }

    //#paginacao
    changePage(event) {
        this.currentPage = event;
        this.offset = (this.currentPage - 1) * + parseInt(this.showItem);
        this.getCollaborators();
    }

    showItemChanged(event){
      this.showItem = event;
      this.currentPage = this.currentPage;
      this.offset = this.offset + (this.currentPage - 1) * + parseInt(this.showItem);
      this.getCollaborators();
    }
    //#endregion

    showCollaborators(checked: boolean){
        this.showItem = this.showItem;
        this.showcollaborators = checked;
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    deleteFilter(){
        this.filtroNome = '';
        this.filtroDocumento = '';
        this.filtroOn = false;

        this.offset = 0;
        this.getCollaborators();
    }

    applyFilter() {
        if(this.nameCtrl.value != null)
            this.filtroNome = this.nameCtrl.value;
        if(this.documentCtrl.value != null)
            this.filtroDocumento = this.documentCtrl.value;
        if(
            this.filtroNome == "" &&
            this.filtroDocumento == ""
        ){
            this.filtroOn = false;
        } else {
            this.filtroOn = true;
        }
        this.offset = 0;
        this.getCollaborators();
    }

    showLimitWarning() {
        this.modalService.open(this.modalAvisoLimite, { centered: true, size: 'lg', backdrop: 'static' });
    }

    navigateToPedidoList(){
        this.router.navigate(['portal/cartoes/list']);
    }

    navigateToCadastroColaborador(){
        this.router.navigate(['portal/colaborador/create']);
    }

    navigateToAssignorInfoEdit(){
        const state: RouterState = this.router.routerState;
        this.router.navigate(['portal/dadoempresa/edit'], { queryParams: { urlReturn: state.snapshot.url } });
    }

}
